import { StarIcon } from "@chakra-ui/icons";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Flex,
  Image,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

const ReadingOrderCard = (props: {
  id: number;
  title: string;
  thumbnail: string;
  comicsCount: number;
  readersCount?: number;
  years: string;
  onClickStart?: () => void;
  premiumOnly?: boolean;
  isPremium?: boolean;
  readingCount?: number;
  hideStartAction?: boolean;
  startActionLabel?: string;
  onClick?: () => void;
  isBookClub?: boolean;
  author?: {
    id: number;
    userHandle: string;
    profilePicture: string;
  };
}) => {
  const readersCount = props.readersCount ?? props.readingCount ?? 0;
  const destination = props.isBookClub
    ? "/community/book-club"
    : `/browse/${props.id}/preview`;

  return (
    <Box borderRadius="lg" bg="gray.700">
      <Link to={destination} onClick={props.onClick}>
        <Box
          h="200px"
          overflow="hidden"
          borderTopRadius="lg"
          borderBottomRadius={!!props.author ? "none" : "lg"}
          bg="gray.700"
          position="relative"
        >
          {props.isBookClub && (
            <Badge
              position="absolute"
              top="3"
              left="3"
              zIndex="1"
              px="2.5"
              py="1"
              borderRadius="full"
              color="white"
              bg="red.500"
              fontSize="0.7em"
              lineHeight="1.2"
              textTransform="none"
              boxShadow="0 2px 8px rgba(0, 0, 0, 0.35)"
            >
              Book club
            </Badge>
          )}
          {!props.isPremium && props.premiumOnly && (
            <Flex
              bg="rgba(0,0,0,0.8)"
              position="absolute"
              right="3"
              top="3"
              borderRadius="lg"
              px="2"
              justifyContent="center"
              alignItems="center"
            >
              <StarIcon boxSize="3" color="#FFAA00" />
              <Text fontSize="0.75em">&nbsp;Preview</Text>
            </Flex>
          )}
          <Box
            h="100%"
            w="100%"
            bgGradient="linear(to-t, black, transparent)"
            position="absolute"
            top="0"
            left="0"
          >
            <Box w="100%" position="absolute" bottom="0">
              <Flex>
                <Box pt="3" px="6">
                  <Text as="h4" fontWeight="bold">
                    {props.title}
                  </Text>
                </Box>
                <Spacer />
              </Flex>
              <Flex
                px="6"
                pb="4"
                pt="0"
                justifyContent="space-between"
                alignItems="center"
              >
                <Text fontSize="0.75em">
                  {!!props.years && `${props.years} • `}
                  {props.comicsCount} comics • {readersCount}{" "}
                  {readersCount === 1 ? "reader" : "readers"}
                </Text>

                {!props.hideStartAction && (
                  <Button
                    variant="outline"
                    size="sm"
                    colorScheme="red"
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      props.onClickStart?.();
                    }}
                  >
                    {props.startActionLabel ?? "Start reading"}
                  </Button>
                )}
              </Flex>
            </Box>
          </Box>
          <Image
            w="100%"
            h="200px"
            objectFit="cover"
            src={props.thumbnail}
            alt={props.title}
          />
        </Box>
      </Link>
      {!!props.author && (
        <Flex w="100%" alignItems="center" justifyContent="flex-end" p="3">
          <Flex flexGrow="1" alignItems="center" justifyContent="flex-end">
            <Box
              flexWrap="wrap"
              display="flex"
              flexDirection="row"
              alignItems="center"
            >
              <Text fontSize="xs" textAlign="right">
                Created by &nbsp;
              </Text>
              <Link to={`/profile/${props.author.userHandle}`}>
                <Text fontSize="sm" as="b">
                  {props.author.userHandle}
                </Text>
              </Link>
            </Box>
            <Link to={`/profile/${props.author.userHandle}`}>
              <Avatar
                size="sm"
                name={props.author.userHandle}
                src={props.author.profilePicture}
                ml="3"
              />
            </Link>
          </Flex>
        </Flex>
      )}
    </Box>
  );
};

export default ReadingOrderCard;
